import { AccessPermissionsEnum } from '@/router/constants';

export default [
  {
    path: 'points',
    name: 'points',

    component: () => import('@/views/points/ViewPoints.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
      icon: 'phone',
      menuItems: 'leftSideMenu.pointsOfSale',
    },
    redirect: {
      name: 'points:list',
    },
    children: [
      {
        path: 'points-list',
        name: 'points:list',

        component: () => import('@/views/points/Points.vue'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
          icon: 'phone',
          menuItems: 'leftSideMenu.pointsOfSale',
        },
        children: [],
      },
      {
        path: 'points-work-time',
        name: 'points:workTime',

        component: () => import('@/views/points/workTime/PointsWorkTime.vue'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
          icon: 'phone',
          menuItems: 'leftSideMenu.pointsOfSale',
        },
        children: [],
      },
      {
        path: 'points-departments',
        name: 'points:departments',

        component: () => import('@/views/points/departments/PointsDepartments.vue'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
          icon: 'phone',
          menuItems: 'leftSideMenu.pointsOfSale',
        },
        children: [],
      },
    ],
  },
  {
    path: 'points/new-point',
    name: 'new-point',

    component: () => import('@/views/points/EditPoint.vue'),
    meta: {
      requiresAuth: true,
      icon: 'phone',
      menuItems: 'leftSideMenu.pointsOfSale',
    },
    children: [],
  },
  {
    path: 'points/edit/:pointId',
    name: 'edit-point',
    component: () => import('@/views/points/EditPoint.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      icon: 'phone',
      menuItems: 'leftSideMenu.pointsOfSale',
    },
    children: [],
  },
];
